import { useState, useEffect } from 'react';
import bgImage from './assets/images/background.png';
import { FaFacebookF, FaLinkedinIn, FaInstagram } from "react-icons/fa";

function App() {
  // Function to get or set target end time in localStorage
  const getTargetTime = () => {
    const saved = localStorage.getItem('countdownEndTime');
    if (saved) return parseInt(saved, 10);

    const now = new Date().getTime();
    const initialDuration =
      1 * 24 * 60 * 60 * 1000 + // 1 day
      1 * 60 * 60 * 1000 +      // 1 hour
      1 * 60 * 1000 +           // 1 min
      20 * 1000;                // 20 sec

    const endTime = now + initialDuration;
    localStorage.setItem('countdownEndTime', endTime);
    return endTime;
  };

  const [timeLeft, setTimeLeft] = useState(0);

  useEffect(() => {
    const target = getTargetTime();

    const interval = setInterval(() => {
      const now = new Date().getTime();
      const distance = target - now;
      setTimeLeft(distance > 0 ? distance : 0);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
  const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const mins = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
  const secs = Math.floor((timeLeft % (1000 * 60)) / 1000);

  const timeUnits = [
    { label: 'days', value: days },
    { label: 'hours', value: hours },
    { label: 'mins', value: mins },
    { label: 'secs', value: secs },
  ];

  return (
    <div
      className="p-10 flex flex-col items-center justify-center gap-10 lg:gap-14 h-screen"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      {/* Countdown */}
      <div className="flex gap-2 lg:gap-4 items-center text-primary text-4xl">
        {timeUnits.map((unit, index) => (
          <div key={unit.label} className="flex items-center gap-2 lg:gap-4">
            <div className="flex flex-col items-center justify-center w-14 h-14 lg:w-24 lg:h-24 bg-primary text-white font-jost text-lg lg:text-3xl">
              {unit.value.toString().padStart(2, '0')}
              <span className="text-sm lg:text-lg opacity-80 tracking-[0.07em]">{unit.label}</span>
            </div>
            {/* Add colon except after the last unit */}
            {index < 3 && <span className="text-2xl lg:text-4xl">:</span>}
          </div>
        ))}
      </div>

      {/* Heading */}
      <div className="flex flex-col items-center gap-2 lg:gap-4">
        <h1 className="font-jost font-semibold text-center text-primary text-4xl lg:text-7xl tracking-normal lg:tracking-[0.03em]">
          COMING SOON
        </h1>
        <p className="font-jost text-xl lg:text-3xl text-primary tracking-[0.1em] text-center">
          Website is under construction.
        </p>
      </div>

      {/* Social Links */}
      <div className="flex flex-col gap-4 items-center justify-center">
        <p className="font-jost text-base lg:text-2xl text-primary tracking-[0.03em]">Find me on:</p>
        <div className="flex gap-4">
          <a
            href="https://www.facebook.com/ridmasony76/"
            className="w-6 h-6 lg:w-8 lg:h-8 rounded-full bg-white flex items-center justify-center"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaFacebookF className="text-primary text-base lg:text-lg transition-colors" />
          </a>
          <a
            href="https://www.instagram.com/sony.baj/"
            className="w-6 h-6 lg:w-8 lg:h-8 rounded-full bg-white flex items-center justify-center"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaInstagram className="text-primary text-base lg:text-lg transition-colors" />
          </a>
          <a
            href="https://www.linkedin.com/in/sony-bajracharya-048120106/"
            className="w-6 h-6 lg:w-8 lg:h-8 rounded-full bg-white flex items-center justify-center"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaLinkedinIn className="text-primary text-base lg:text-lg transition-colors" />
          </a>
        </div>
      </div>
    </div>
  );
}

export default App;
